<template lang="html">
  <!-- <v-flex ref="chart" pa-0 style="max-height:400px;position: relative;" d-block> </v-flex> -->
  <apexcharts
    width="100%"
    :height="height"
    type="line"
    :options="chartOptions"
    :series="series"
  />
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexcharts: VueApexCharts
  },
  props: {
    labels: Array,
    series: Array,
    options: Object,
    height: {
      type: Number,
      default: 400
    }
  },
  data () {
    return {
    }
  },
  computed: {
    chartDefault () {
      return {
        chart: {
          // zoom: {
          //   type: 'x',
          //   enabled: true
          // },
        },
        stroke: {
            width: 3,
        },
        series: this.series,
        xaxis: {
          categories: this.labels
        }
      }
    },
    chartOptions () {
      return { ...this.chartDefault, ...this.options }
    }
  },
  watch: {
  },
  mounted () {

  }
}
</script>

<style lang="css" scoped>

</style>
